import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((theme) => ({
  orderMethod: {
    appearance: 'none',
    border: 'none',
    background: 'none',
    padding: '1rem 2rem',
    maxWidth: '100%',
    cursor: 'pointer',
    color: theme.colors.text,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  },
  leftContent: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexGrow: 0,
    flexShrink: 1,
    fontSize: '1.4rem',
    lineHeight: '1.2em',
  },
  orderMethodValue: {
    fontWeight: 600,
  },
  orderMethodIcon: {
    flexGrow: 0,
    flexShrink: 0,
  },
}))

export default useStyles
